import { render } from "./RelatedRequests.vue?vue&type=template&id=82a8f090"
import script from "./RelatedRequests.vue?vue&type=script&lang=js"
export * from "./RelatedRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__